import { useEffect, useRef, useState } from 'react';
import './GuestSelector.css';

export default function GuestSelector({ value, onChange, max = 10, name, id, error = false, describedBy, compact = false }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const count = Number(value) || 0;

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const closeOnEscape = event => { if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); } };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  function update(next) {
    onChange(Math.max(0, Math.min(max, next)));
  }

  return <div ref={root} className={`guest-selector${compact ? ' guest-selector--compact' : ''}`}>
    {name && <input type="hidden" name={name} value={count || ''} />}
    <button ref={trigger} id={id} className={`guest-selector__trigger${error ? ' is-invalid' : ''}`} type="button" aria-label={`Guests: ${count ? `${count} ${count === 1 ? 'guest' : 'guests'}` : 'Add guests'}`} aria-haspopup="dialog" aria-expanded={open} aria-describedby={describedBy} onClick={() => setOpen(state => !state)}>
      <span>{count ? `${count} ${count === 1 ? 'guest' : 'guests'}` : 'Add guests'}</span><span className="guest-selector__chevron" aria-hidden="true">⌄</span>
    </button>
    {open && <div className="guest-selector__panel" role="dialog" aria-label="Add guests">
      <div className="guest-selector__row"><div><strong>Guests</strong><span>Maximum {max}</span></div><div className="guest-selector__stepper" role="group" aria-label="Guest count">
        <button type="button" aria-label="Decrease guests" disabled={count <= 0} onClick={() => update(count - 1)}>−</button>
        <output aria-live="polite">{count}</output>
        <button type="button" aria-label="Increase guests" disabled={count >= max} onClick={() => update(count + 1)}>+</button>
      </div></div>
      <button className="guest-selector__done" type="button" onClick={() => setOpen(false)}>Done</button>
    </div>}
  </div>;
}
